import { Box, Skeleton, u } from '@ui';

import * as css from '../NotificationMenu.css';

export const SkeletonMenuItem = () => {
    return (
        <Box px={16} className={css.skeletonBackground}>
            <header className={css.notificationHeader()}>
                <Skeleton display="flex" width="50%" className={css.skeleton({ height: 1.5 })} shade={400} />
            </header>
            <Skeleton
                display="flex"
                width="50%"
                mt={u(1)}
                mb={u(0.5)}
                className={css.skeleton({ height: 2 })}
                shade={400}
            />
            <Skeleton display="flex" width="100%" className={css.skeleton({ height: 3 })} shade={400} />
            <footer className={css.notificationSince()}>
                <Skeleton display="flex" width="50%" className={css.skeleton({ height: 1.5 })} shade={400} />
                <Box display="flex" gap={u(1)}>
                    <Skeleton shade={400} className={css.skeletonFooterIcons} />
                    <Skeleton shade={400} className={css.skeletonFooterIcons} />
                    <Skeleton shade={400} className={css.skeletonFooterIcons} />
                </Box>
            </footer>
        </Box>
    );
};
